import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
import { clearQueries } from '../lib/Queries';

const ErrorPage = ({}) => {
    const error = useRouteError();
    console.error(error);

    useEffect(() => {
        // Clear out query cache in case it's bad data
        clearQueries();
    }, []);

    let message = '';
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            message = 'Page not found';
        }
    }

    return (
        <div className="min-h-screen w-full bg-gray-100 flex items-center justify-center">
            <div className="p-6 panel">
                <h2>{message || 'Error!'}</h2>
                <p className="mt-2">
                    Please refresh the page and try again.
                    <br />
                    If this problem continues please{' '}
                    <a href="mailto:support@breely.com">contact support</a>.
                </p>
            </div>
        </div>
    );
};

export default ErrorPage;
